import { Suspense } from "react";
import UniversalLoading from "@/components/loading/UniversalLoading";
import PicassoContentReview from "@/components/admin/pages/PicassoContentReview";
import { usePicassoAuth } from "@/hooks/common/usePicassoAuth";

export const ContentReviewView = () => {
  const { isAdmin, userEmail } = usePicassoAuth();

  
  return (
    <Suspense
      fallback={
        <div className="overflow-y-hidden">
          <UniversalLoading 
            variant={isAdmin ? "admin" : "auth"} 
            message="Loading content review..." 
          />
        </div>
      }
    >
      <PicassoContentReview isAdmin={isAdmin} userEmail={userEmail} />
    </Suspense>
  );
};

export default ContentReviewView;
